export default {"src":"/_next/static/image/public/assets/logos/black-logo-name.4b7dc9f4e88163f13780a7ee9d67960c.svg","height":51,"width":238};